import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: { height: '100%' },
    headerContainer: { paddingBottom: '1.5rem' },
    panelHeader: {
        color: theme?.app?.applicationColors.enumColors.black || '#000000',
        fontSize: '.8rem',
        textTransform: 'uppercase' as const,
        fontWeight: 'bold' as const
    },
    userCount: {
        fontSize: '.8rem',
        color: theme?.app?.applicationColors.fontDetailColor || '#4A4C50'
    },
    mapUserButtonContainer: { alignSelf: 'flex-end' as const }
});